import { render, staticRenderFns } from "./RegisterFormSaas.vue?vue&type=template&id=5cb7468a"
import script from "./RegisterFormSaas.vue?vue&type=script&lang=js"
export * from "./RegisterFormSaas.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormSaas.vue?vue&type=style&index=0&id=5cb7468a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports